import * as i0 from '@angular/core';
import { EventEmitter, Directive, Output, HostListener, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

class ClickOutsideDirective {
    constructor(_elRef) {
        this._elRef = _elRef;
        this.uprClickOutside = new EventEmitter();
    }
    clickout(event) {
        if (this._elRef.nativeElement.contains(event.target)) {
            return;
        }
        this.uprClickOutside.emit(event);
    }
}
ClickOutsideDirective.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: ClickOutsideDirective, deps: [{ token: i0.ElementRef }], target: i0.ɵɵFactoryTarget.Directive });
ClickOutsideDirective.ɵdir = i0.ɵɵngDeclareDirective({ minVersion: "12.0.0", version: "13.3.11", type: ClickOutsideDirective, selector: "[uprClickOutside]", outputs: { uprClickOutside: "uprClickOutside" }, host: { listeners: { "document:click": "clickout($event)" } }, ngImport: i0 });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: ClickOutsideDirective, decorators: [{
            type: Directive,
            args: [{
                    selector: '[uprClickOutside]'
                }]
        }], ctorParameters: function () { return [{ type: i0.ElementRef }]; }, propDecorators: { uprClickOutside: [{
                type: Output
            }], clickout: [{
                type: HostListener,
                args: ['document:click', ['$event']]
            }] } });

class ClickOutsideModule {
}
ClickOutsideModule.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: ClickOutsideModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
ClickOutsideModule.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: ClickOutsideModule, declarations: [ClickOutsideDirective], imports: [CommonModule], exports: [ClickOutsideDirective] });
ClickOutsideModule.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: ClickOutsideModule, imports: [[CommonModule]] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: ClickOutsideModule, decorators: [{
            type: NgModule,
            args: [{
                    imports: [CommonModule],
                    declarations: [ClickOutsideDirective],
                    exports: [ClickOutsideDirective]
                }]
        }] });

export { ClickOutsideDirective, ClickOutsideModule };
